import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetCustomersShort, EntityStatus } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCustomersShortInfo } from 'backend/customers';
import { useTranslation } from 'react-i18next';
import { ISelectOption } from 'components/Select/types';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';

interface ICustomerSelect {
	setCustomer: (value: Nullable<string>) => void;
	setFetchedCustomers: (value: IItemForGetShortInfo[]) => void;
}

const CustomerSelect: React.FC<ICustomerSelect> = ({ setCustomer, setFetchedCustomers }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCustomersShort, null>(getCustomersShortInfo);
	const { t } = useTranslation('error');

	useEffect(() => {
		response && setFetchedCustomers(response.data.customers);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('select customer') }], [t]);

	const options = useMemo<ISelectOption[]>(() => {
		const items = response?.data.customers || [];

		return items.map((customer) => ({
			...customer,
			additionalContent: customer.status === EntityStatus.Archived ? <ArchivedLabel /> : undefined,
		}));
	}, [response]);

	return (
		<FormSelect
			testId="CustomerSelect"
			name="selectedCustomer"
			label="customerLabel"
			disabled={true}
			options={options}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setCustomer}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CustomerSelect);
